import { Directive, ViewContainerRef, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AmazingTimePickerService } from './atp-time-picker.service';
export class AtpDirective implements ControlValueAccessor {

   myClick = new EventEmitter();
private elementRef: ElementRef;
private onChange = (x: any): void => {};
/**
 * @param {?} viewContainerRef
 * @param {?} atp
 */
constructor(
public viewContainerRef: ViewContainerRef,
private atp: AmazingTimePickerService) {
    this.elementRef = this.viewContainerRef.element;
  }
/**
 * @param {?} e
 * @return {?}
 */
onClick(e) {
    const /** @type {?} */ ele = this.viewContainerRef.element.nativeElement;
    const /** @type {?} */ time = ele.value;
    const /** @type {?} */ theme = ele.getAttribute('theme');
    const /** @type {?} */ start = ele.getAttribute('start');
    const /** @type {?} */ end = ele.getAttribute('end');
    const /** @type {?} */ locale = ele.getAttribute('locale') || 'en';
    const /** @type {?} */ changeToMinutes = ele.getAttribute('changeToMinutes') === 'true';
    const /** @type {?} */ animation = ele.getAttribute('animation');
    const /** @type {?} */ preference = ele.getAttribute('preference') || null;
    const /** @type {?} */ onlyHour = ele.getAttribute('onlyHour') === 'true';
    const /** @type {?} */ onlyMinute = ele.getAttribute('onlyMinute') === 'true';
    const /** @type {?} */ onlyAM = ele.getAttribute('onlyAM') === 'true';
    const /** @type {?} */ onlyPM = ele.getAttribute('onlyPM') === 'true';
    let /** @type {?} */ arrowStyle = ele.getAttribute('arrowStyle');
    arrowStyle = (arrowStyle) ? JSON.parse(arrowStyle.replace(new RegExp('\'', 'g'), '"')) : '';
    const /** @type {?} */ timePickerFunction = this.atp.open({
      time,
      theme,
      rangeTime: { start, end},
      'arrowStyle': arrowStyle,
      locale,
      changeToMinutes,
      animation,
      onlyHour,
      onlyMinute,
      onlyAM,
      onlyPM,
      preference
    });

    timePickerFunction.afterClose().subscribe(retTime => {
      this.writeValue(retTime); // update the native element
      this.onChange(retTime); // update the form value (if there's a form)
    });
  }
/**
 * @param {?} e
 * @return {?}
 */
onInput(e: any) {
    this.onChange(e.srcElement.value);
  }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any) {
    if (this.elementRef) {
      this.elementRef.nativeElement.value = value;
    }
  }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: any) {
    this.onChange = fn;
  }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn) {  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'input[atp-time-picker]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: AtpDirective,
    multi: true
  }]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
{type: AmazingTimePickerService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'myClick': [{ type: Output },],
'onClick': [{ type: HostListener, args: ['click', ['$event'], ] },],
'onInput': [{ type: HostListener, args: ['input', ['$event'], ] },],
};
}

function AtpDirective_tsickle_Closure_declarations() {
/** @type {?} */
AtpDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AtpDirective.ctorParameters;
/** @type {?} */
AtpDirective.propDecorators;
/** @type {?} */
AtpDirective.prototype.myClick;
/** @type {?} */
AtpDirective.prototype.elementRef;
/** @type {?} */
AtpDirective.prototype.onChange;
/** @type {?} */
AtpDirective.prototype.viewContainerRef;
/** @type {?} */
AtpDirective.prototype.atp;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
